import React, { useEffect, useRef, useState } from "react";
import "../../css_files/Reports/ETQGraphs.css";
import { Chart } from "chart.js";
import axiosInstance from "../../api";

function ETQGraphs({ title, setHeadings, setDetails, setShowDetails }) {
  const chartRef = useRef([]);
  const chartInstance = useRef([]);

  const [data, setData] = useState({
    date: new Date().toISOString().split("T")[0],
    month: (new Date().getMonth() + 1).toString().padStart(2, "0"),
    year: new Date().getFullYear().toString(),
  });

  const [enquiryData, setEnquiryData] = useState([]);
  const [ticketData, setTicketData] = useState([]);
  const [quotationData, setQuotationData] = useState([]);

  function getAllEnquiries() {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/NewEnquiry/GetEnquiriesDropdown`
      )
      .then((res) => {
        setEnquiryData(res.data);
      })
      .catch(console.log);
  }

  function getAllTickets() {
    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Ticket/GetTicketsDropdown`)
      .then((res) => {
        setTicketData(res.data);
      })
      .catch(console.log);
  }

  function getAllQuotations() {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Quotation/GetQuotationDropdown`
      )
      .then((res) => {
        setQuotationData(res.data);
      })
      .catch(console.log);
  }

  useEffect(() => {
    getAllEnquiries();
    getAllTickets();
    getAllQuotations();
  }, []);

  function getAsofTodayByTitle(title, enquiryType, date) {
    switch (title) {
      case "Enquiries":
        return enquiryData.reduce((acc, curr) => {
          if (
            curr.dateOfEnquiry.split("T")[0] === date &&
            curr.enquiryType === enquiryType
          ) {
            return acc + 1;
          }
          return acc;
        }, 0);

      case "Tickets":
        return ticketData.reduce((acc, curr) => {
          const ticketDate = `${curr.seriesId.slice(
            0,
            4
          )}-${curr.seriesId.slice(4, 6)}-${curr.seriesId.slice(6, 8)}`;
          if (ticketDate === date && curr.enquiryType === enquiryType) {
            return acc + 1;
          }
          return acc;
        }, 0);

      case "Quotations":
        return quotationData.reduce((acc, curr) => {
          const quotationDate = curr.createdDate.split("T")[0];
          if (quotationDate === date && curr.enquiryType === enquiryType) {
            return acc + 1;
          }
          return acc;
        }, 0);

      case "Combination":
        let count = 0;

        count += enquiryData.reduce((acc, curr) => {
          if (
            curr.dateOfEnquiry.split("T")[0] === date &&
            curr.enquiryType === enquiryType
          ) {
            return acc + 1;
          }
          return acc;
        }, 0);

        count += ticketData.reduce((acc, curr) => {
          const ticketDate = `${curr.seriesId.slice(
            0,
            4
          )}-${curr.seriesId.slice(4, 6)}-${curr.seriesId.slice(6, 8)}`;
          if (ticketDate === date && curr.enquiryType === enquiryType) {
            return acc + 1;
          }
          return acc;
        }, 0);

        count += quotationData.reduce((acc, curr) => {
          const quotationDate = curr.createdDate.split("T")[0];
          if (quotationDate === date && curr.enquiryType === enquiryType) {
            return acc + 1;
          }
          return acc;
        }, 0);

        return count;

      default:
        return 0;
    }
  }

  function getAsofToday() {
    if (!chartRef.current) return;

    const ctx = chartRef.current[0];
    chartInstance.current[0] = new Chart(ctx, {
      type: "pie",
      data: {
        labels: ["Service", "Parts"],
        datasets: [
          {
            label: `${title} in ${data.date}`,
            data: [
              getAsofTodayByTitle(title, "Service", data.date),
              getAsofTodayByTitle(title, "Parts", data.date),
            ],
            backgroundColor: ["#FF6384", "#36A2EB"],
            hoverOffset: 4,
          },
        ],
      },
    });
  }

  function getDaysofMonth(month, year) {
    switch (month) {
      case "01":
      case "03":
      case "05":
      case "07":
      case "08":
      case "10":
      case "12":
        return 31;
      case "02":
        if (parseInt(year) % 4 === 0 || parseInt(year) % 100 === 0) return 29;
        else return 28;

      case "04":
      case "06":
      case "09":
      case "11":
        return 30;
    }
  }

  function getAsofMonth() {
    if (!chartRef.current) return;
    const ctx = chartRef.current[1];
    chartInstance.current[1] = new Chart(ctx, {
      type: title === "Combination" ? "bar" : "line",
      data: {
        labels: Array.from(
          { length: getDaysofMonth(data.month, data.year) },
          (_, i) => i + 1
        ),
        datasets: [
          title !== "Combination" && {
            label: `${title} in ${getMonthByNumber(data.month)}`,
            data: Array.from(
              { length: getDaysofMonth(data.month, data.year) },
              (_, i) => {
                switch (title) {
                  case "Enquiries":
                    return enquiryData.reduce((acc, curr) => {
                      const dateArr = curr.dateOfEnquiry
                        .split("T")[0]
                        .split("-");
                      if (
                        dateArr[0] == data.year &&
                        dateArr[1] == data.month &&
                        parseInt(dateArr[2]) === i + 1
                      ) {
                        return acc + 1;
                      }
                      return acc;
                    }, 0);
                  case "Tickets":
                    return ticketData.reduce((acc, curr) => {
                      if (
                        curr.seriesId.slice(0, 4) == data.year &&
                        curr.seriesId.slice(4, 6) == data.month &&
                        parseInt(curr.seriesId.slice(6, 8)) === i + 1
                      ) {
                        return acc + 1;
                      }
                      return acc;
                    }, 0);
                  case "Quotations":
                    return quotationData.reduce((acc, curr) => {
                      const split = curr.createdDate.split("T")[0].split("-");
                      if (
                        split[0] == data.year &&
                        split[1] == data.month &&
                        parseInt(split[2]) === i + 1
                      ) {
                        return acc + 1;
                      }
                      return acc;
                    }, 0);
                }
              }
            ),
            borderWidth: 1,
            borderColor: "blue",
            backgroundColor: "rgba(0, 0, 255, 0.1)",
            tension: 0.3,
          },
          title === "Combination" && {
            label: `Enquiries in ${getMonthByNumber(data.month)}`,
            data: Array.from(
              { length: getDaysofMonth(data.month, data.year) },
              (_, i) =>
                enquiryData.reduce((acc, curr) => {
                  const dateArr = curr.dateOfEnquiry.split("T")[0].split("-");
                  if (
                    dateArr[0] == data.year &&
                    dateArr[1] == data.month &&
                    parseInt(dateArr[2]) === i + 1
                  ) {
                    return acc + 1;
                  }
                  return acc;
                }, 0)
            ),
            borderWidth: 1,
            borderColor: "red",
          },
          title === "Combination" && {
            label: `Tickets in ${getMonthByNumber(data.month)}`,
            data: Array.from(
              { length: getDaysofMonth(data.month, data.year) },
              (_, i) =>
                ticketData.reduce((acc, curr) => {
                  if (
                    curr.seriesId.slice(0, 4) == data.year &&
                    curr.seriesId.slice(4, 6) == data.month &&
                    parseInt(curr.seriesId.slice(6, 8)) === i + 1
                  ) {
                    return acc + 1;
                  }
                  return acc;
                }, 0)
            ),
            borderWidth: 1,
            borderColor: "green",
          },
          title === "Combination" && {
            label: `Quotations in ${getMonthByNumber(data.month)}`,
            data: Array.from(
              { length: getDaysofMonth(data.month, data.year) },
              (_, i) =>
                quotationData.reduce((acc, curr) => {
                  const split = curr.createdDate.split("T")[0].split("-");
                  if (
                    split[0] == data.year &&
                    split[1] == data.month &&
                    parseInt(split[2]) === i + 1
                  ) {
                    return acc + 1;
                  }
                  return acc;
                }, 0)
            ),
            borderWidth: 1,
            borderColor: "blue",
          },
        ].filter(Boolean),
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        onClick: (_, ele) => {
          switch (title) {
            case "Enquiries":
              const enquiriesHeadings = [
                "Sr.No.",
                "Series Id",
                "Enquiry Type",
                "Date of Enquiry",
                "Priority",
                "Company/Organization Name",
                "Ship To Address",
                "Bill To Adddress",
              ];
              getEnquiryDetails("month", enquiryData, ele, enquiriesHeadings);
              break;
            case "Tickets":
              const ticketHeadings = [
                "Sr.No.",
                "Ticket Id",
                "Company/Organization Name",
                "Linked to Enquiry",
                "Service Type",
                "Due Date",
                "Status",
              ];
              getTicketDetails("month", ticketData, ele, ticketHeadings);
              break;
            case "Quotations":
              const quotationHeadings = [
                "Sr.No.",
                "Series Id",
                "Quotation Type",
                "Linked To Ticket Id",
                "SubTotal",
                "Packing and Forwarding Charges",
                "Courier Expenditure",
                "GST Amount",
                "Discount Amount",
                "Final Total",
                "Grand Total",
                "Created Date",
              ];

              getQuotationDetails(
                "month",
                quotationData,
                ele,
                quotationHeadings
              );
              break;
            case "Combination":
              switch (ele[0]?.datasetIndex) {
                case 0:
                  const enquiriesHeadings = [
                    "Sr.No.",
                    "Series Id",
                    "Enquiry Type",
                    "Date of Enquiry",
                    "Priority",
                    "Company/Organization Name",
                    "Ship To Address",
                    "Bill To Adddress",
                  ];
                  getEnquiryDetails(
                    "month",
                    enquiryData,
                    ele,
                    enquiriesHeadings
                  );
                  break;
                case 1:
                  const ticketHeadings = [
                    "Sr.No.",
                    "Ticket Id",
                    "Company/Organization Name",
                    "Linked to Enquiry",
                    "Service Type",
                    "Due Date",
                    "Status",
                  ];
                  getTicketDetails("month", ticketData, ele, ticketHeadings);
                  break;
                case 2:
                  const quotationHeadings = [
                    "Sr.No.",
                    "Series Id",
                    "Quotation Type",
                    "Linked To Ticket Id",
                    "SubTotal",
                    "Packing and Forwarding Charges",
                    "Courier Expenditure",
                    "GST Amount",
                    "Discount Amount",
                    "Final Total",
                    "Grand Total",
                    "Created Date",
                  ];

                  getQuotationDetails(
                    "month",
                    quotationData,
                    ele,
                    ticketHeadings
                  );
                  break;
              }
              break;
          }
        },
      },
    });
  }

  function getAsofYear() {
    if (!chartRef.current) return;
    const ctx = chartRef.current[2];
    chartInstance.current[2] = new Chart(ctx, {
      type: title === "Combination" ? "bar" : "line",
      data: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        datasets: [
          title !== "Combination" && {
            label: `${title} in ${data.year}`,
            data: Array.from({ length: 12 }, (_, i) => {
              switch (title) {
                case "Enquiries":
                  return enquiryData.reduce((acc, curr) => {
                    const dateArr = curr.dateOfEnquiry.split("T")[0].split("-");
                    if (
                      dateArr[0] == data.year &&
                      parseInt(dateArr[1]) === i + 1
                    ) {
                      return acc + 1;
                    }
                    return acc;
                  }, 0);
                case "Tickets":
                  return ticketData.reduce((acc, curr) => {
                    if (
                      curr.seriesId.slice(0, 4) == data.year &&
                      parseInt(curr.seriesId.slice(4, 6)) === i + 1
                    ) {
                      return acc + 1;
                    }
                    return acc;
                  }, 0);
                case "Quotations":
                  return quotationData.reduce((acc, curr) => {
                    const split = curr.createdDate.split("T")[0].split("-");
                    if (split[0] == data.year && parseInt(split[1]) === i + 1) {
                      return acc + 1;
                    }
                    return acc;
                  }, 0);
              }
            }),
            borderWidth: 1,
            borderColor: "blue",
            backgroundColor: "rgba(0, 0, 255, 0.1)",
            tension: 0.3,
          },
          title === "Combination" && {
            label: `Enquiries in ${data.year}`,
            data: Array.from({ length: 12 }, (_, i) =>
              enquiryData.reduce((acc, curr) => {
                const dateArr = curr.dateOfEnquiry.split("T")[0].split("-");
                if (dateArr[0] == data.year && parseInt(dateArr[1]) === i + 1) {
                  return acc + 1;
                }
                return acc;
              }, 0)
            ),
            borderWidth: 1,
            borderColor: "red",
          },
          title === "Combination" && {
            label: `Tickets in ${data.year}`,
            data: Array.from({ length: 12 }, (_, i) =>
              ticketData.reduce((acc, curr) => {
                if (
                  curr.seriesId.slice(0, 4) == data.year &&
                  parseInt(curr.seriesId.slice(4, 6)) === i + 1
                ) {
                  return acc + 1;
                }
                return acc;
              }, 0)
            ),
            borderWidth: 1,
            borderColor: "green",
          },
          title === "Combination" && {
            label: `Quotations in ${data.year}`,
            data: Array.from({ length: 12 }, (_, i) =>
              quotationData.reduce((acc, curr) => {
                const split = curr.createdDate.split("T")[0].split("-");
                if (split[0] == data.year && parseInt(split[1]) === i + 1) {
                  return acc + 1;
                }
                return acc;
              }, 0)
            ),
            borderWidth: 1,
            borderColor: "blue",
          },
        ].filter(Boolean),
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        onClick: (_, ele) => {
          switch (title) {
            case "Enquiries":
              const enquiriesHeadings = [
                "Sr.No.",
                "Series Id",
                "Enquiry Type",
                "Date of Enquiry",
                "Priority",
                "Company/Organization Name",
                "Ship To Address",
                "Bill To Adddress",
              ];
              getEnquiryDetails("year", enquiryData, ele, enquiriesHeadings);
              break;
            case "Tickets":
              const ticketHeadings = [
                "Sr.No.",
                "Ticket Id",
                "Company/Organization Name",
                "Linked to Enquiry",
                "Service Type",
                "Due Date",
                "Status",
              ];
              getTicketDetails("year", ticketData, ele, ticketHeadings);
              break;
            case "Quotations":
              const quotationHeadings = [
                "Sr.No.",
                "Series Id",
                "Quotation Type",
                "Linked To Ticket Id",
                "SubTotal",
                "Packing and Forwarding Charges",
                "Courier Expenditure",
                "GST Amount",
                "Discount Amount",
                "Final Total",
                "Grand Total",
                "Created Date",
              ];

              getQuotationDetails(
                "year",
                quotationData,
                ele,
                quotationHeadings
              );
              break;
            case "Combination":
              switch (ele[0]?.datasetIndex) {
                case 0:
                  const enquiriesHeadings = [
                    "Sr.No.",
                    "Series Id",
                    "Enquiry Type",
                    "Date of Enquiry",
                    "Priority",
                    "Company/Organization Name",
                    "Ship To Address",
                    "Bill To Adddress",
                  ];
                  getEnquiryDetails(
                    "year",
                    enquiryData,
                    ele,
                    enquiriesHeadings
                  );
                  break;
                case 1:
                  const ticketHeadings = [
                    "Sr.No.",
                    "Ticket Id",
                    "Company/Organization Name",
                    "Linked to Enquiry",
                    "Service Type",
                    "Due Date",
                    "Status",
                  ];
                  getTicketDetails("year", ticketData, ele, ticketHeadings);

                  break;
                case 2:
                  const quotationHeadings = [
                    "Sr.No.",
                    "Series Id",
                    "Quotation Type",
                    "Linked To Ticket Id",
                    "SubTotal",
                    "Packing and Forwarding Charges",
                    "Courier Expenditure",
                    "GST Amount",
                    "Discount Amount",
                    "Final Total",
                    "Grand Total",
                    "Created Date",
                  ];
                  getQuotationDetails(
                    "year",
                    quotationData,
                    ele,
                    quotationHeadings
                  );
                  break;
              }
              break;
          }
        },
      },
    });
  }

  function getMonthByNumber(num) {
    switch (num) {
      case "01":
        return "January";
      case "02":
        return "February";
      case "03":
        return "March";
      case "04":
        return "April";
      case "05":
        return "May";
      case "06":
        return "June";
      case "07":
        return "July";
      case "08":
        return "August";
      case "09":
        return "September";
      case "10":
        return "October";
      case "11":
        return "November";
      case "12":
        return "December";
    }
  }

  useEffect(() => {
    getAsofToday();
    getAsofMonth();
    getAsofYear();

    return () => {
      chartInstance.current[0]?.destroy();
      chartInstance.current[1]?.destroy();
      chartInstance.current[2]?.destroy();
    };
  }, [data, enquiryData, ticketData, quotationData]);

  function getEnquiryDetails(condition, enquiryData, ele, enquiriesHeadings) {
    Promise.all(
      enquiryData
        .filter((x) => {
          const split = x.dateOfEnquiry.split("T")[0].split("-");
          if (condition == "year") {
            return (
              split[0] == data.year && parseInt(split[1]) === ele[0]?.index + 1
            );
          } else if (condition == "month") {
            return (
              split[0] == data.year &&
              split[1] == data.month &&
              parseInt(split[2]) === ele[0]?.index + 1
            );
          }
          return false;
        })
        .map((x) =>
          axiosInstance.get(
            `${process.env.REACT_APP_API_URL}/api/v1/NewEnquiry/GetEnquiryById?seriesId=${x.seriesID}`
          )
        )
    ).then((x) => {
      const enquiries = x
        .map((x) => x.data)
        .map((x, i) => [
          i + 1,
          x.seriesID,
          x.enquiryType,
          new Date(x.dateOfEnquiry).toDateString(),
          x.priority,
          x.customer.orgName,
          `${x.shipToAddress.addressType}: ${
            x.shipToAddress.officeName || x.shipToAddress.factoryName
          }, ${x.shipToAddress.address1}, ${x.shipToAddress.address2}, ${
            x.shipToAddress.cityObj.name
          }, ${x.shipToAddress.stateObj.name}, ${x.shipToAddress.country}, ${
            x.shipToAddress.pincode
          }`,
          `${x.billToAddress.addressType}: ${
            x.billToAddress.officeName || x.billToAddress.factoryName
          }, ${x.billToAddress.address1}, ${x.billToAddress.address2}, ${
            x.billToAddress.cityObj.name
          }, ${x.billToAddress.stateObj.name}, ${x.billToAddress.country}, ${
            x.billToAddress.pincode
          }`,
        ]);
      setShowDetails(true);
      setDetails(enquiries);
      setHeadings(enquiriesHeadings);
    });
  }

  function getTicketDetails(condition, ticketData, ele, ticketHeadings) {
    Promise.all(
      ticketData
        .filter((x) => {
          if (condition == "year") {
            const year = x.seriesId.slice(0, 4);
            const month = parseInt(x.seriesId.slice(4, 6));
            return year == data.year && month === ele[0]?.index + 1;
          } else if (condition == "month") {
            const year = x.seriesId.slice(0, 4);
            const month = x.seriesId.slice(4, 6);
            const day = parseInt(x.seriesId.slice(6, 8));
            return (
              year == data.year &&
              month == data.month &&
              day === ele[0]?.index + 1
            );
          }
          return false;
        })
        .map((x) =>
          axiosInstance.get(
            `${process.env.REACT_APP_API_URL}/api/v1/Ticket/${x.seriesId}`
          )
        )
    ).then((x) => {
      const ticketsData = x
        .map((x) => x.data)
        .map((x, i) => [
          i + 1,
          x.seriesId,
          x.customer.orgName,
          x.enquirySeriesId,
          x.enquiryType,
          new Date(x.serviceDetails.dueDate).toDateString(),
          x.status,
        ]);
      setShowDetails(true);
      setDetails(ticketsData);
      setHeadings(ticketHeadings);
    });
  }

  function getQuotationDetails(
    condition,
    quotationData,
    ele,
    quotationHeadings
  ) {
    Promise.all(
      quotationData
        .filter((x) => {
          const split = x.createdDate.split("T")[0].split("-");
          if (condition == "year") {
            return (
              data.year === split[0] && ele[0]?.index + 1 === parseInt(split[1])
            );
          } else if (condition == "month") {
            return (
              data.year === split[0] &&
              data.month === split[1] &&
              ele[0]?.index + 1 === parseInt(split[2])
            );
          }
          return false;
        })
        .map((x) =>
          axiosInstance.get(
            `${process.env.REACT_APP_API_URL}/api/v1/Quotation/${x.seriesId}`
          )
        )
    ).then((x) => {
      const quotations = x
        .map((x) => x.data)
        .map((x, i) => [
          i + 1,
          x.seriesId,
          x.enquiryType,
          x.ticketId,
          `${x.symbol} ${x.subTotal}`,
          x.enquiryType === "Service"
            ? "N/A"
            : `${x.symbol} ${x.packingForwarding}`,
          x.enquiryType === "Service" ? "N/A" : `${x.symbol} ${x.courierExp}`,
          `${x.symbol} ${x.gstAmount}`,
          `${x.symbol} ${x.discountValue}`,
          `${x.symbol} ${x.finalTotal}`,
          `${x.symbol} ${x.grandTotal}`,
          new Date(x.createdDate).toDateString(),
        ]);
      setShowDetails(true);
      setDetails(quotations);
      setHeadings(quotationHeadings);
    });
  }

  return (
    <section className="ETQ-graphs">
      <center>
        <h2>{title}</h2>
      </center>
      <div>
        <aside>
          <blockquote>
            <label>As of Today</label>
            <input
              type="date"
              onChange={(e) => setData({ ...data, date: e.target.value })}
              value={data.date}
            />
          </blockquote>
          <figure>
            <canvas ref={(el) => (chartRef.current[0] = el)}></canvas>
          </figure>
        </aside>
        <aside style={{ gridColumn: "span 2" }}>
          <blockquote>
            <label>As of Month</label>
            <select
              onChange={(e) => setData({ ...data, month: e.target.value })}
            >
              <option value="">Select Month</option>
              <option value="01" selected={data.month === "01"}>
                January
              </option>
              <option value="02" selected={data.month === "02"}>
                February
              </option>
              <option value="03" selected={data.month === "03"}>
                March
              </option>
              <option value="04" selected={data.month === "04"}>
                April
              </option>
              <option value="05" selected={data.month === "05"}>
                May
              </option>
              <option value="06" selected={data.month === "06"}>
                June
              </option>
              <option value="07" selected={data.month === "07"}>
                July
              </option>
              <option value="08" selected={data.month === "08"}>
                August
              </option>
              <option value="09" selected={data.month === "09"}>
                September
              </option>
              <option value="10" selected={data.month === "10"}>
                October
              </option>
              <option value="11" selected={data.month === "11"}>
                November
              </option>
              <option value="12" selected={data.month === "12"}>
                December
              </option>
            </select>
          </blockquote>
          <figure>
            <canvas ref={(el) => (chartRef.current[1] = el)}></canvas>
          </figure>
        </aside>
        <aside style={{ gridColumn: "span 2" }}>
          <blockquote>
            <label>As of Year</label>
            <select
              onChange={(e) => setData({ ...data, year: e.target.value })}
            >
              <option value="">Select Year</option>
              {Array.from({ length: 150 }, (_, i) => `${1970 + i}`).map((x) => (
                <option value={x} selected={data.year === x}>
                  {x}
                </option>
              ))}
            </select>
          </blockquote>
          <figure>
            <canvas ref={(el) => (chartRef.current[2] = el)}></canvas>
          </figure>
        </aside>
      </div>
    </section>
  );
}

export default ETQGraphs;
